require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-116-trello-powerup.json") })
        }
      }, "path---article-116-trello-powerup");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-116-trello-powerup!./.cache/json/article-116-trello-powerup.json
// module id = 473
// module chunks = 231608221292675